import React, { useEffect, useState } from "react";
import YesNoTable from "../../Components/yesNoTable";
import { Route, Routes, useSearchParams } from "react-router-dom";
import MarkesEvaluationTable from "../../Components/MarkesEvaluationTable";
import RecommendationsSection from "../../Components/RecommendationsSection";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import RequestsManager from "../../ContainersManager/RequestsManager";
import TasksManager from "../../ContainersManager/TasksManager";
import ButtonActionManager from "../../PagesManager/ButtonActionManager";
import SingleTaskManager from "../../PagesManager/SingleTaskManager";
import SingelTaskManagerContainer from "../../ContainersManager/SingelTaskManagerContainer";
import AllComponentPage from "../../PagesManager/AllComponentPage";
import { useDispatch, useSelector } from "react-redux";
import { GetRoleByUserGuid } from "../../Redux/Reducers/RoleByUser";

import AllMainComponentsPage from "../../PagesManager/AllMainComponentsPage";

import ApplicantInformatonPage from "../../Containers/ApplicantInformatonPage";
import ProjectInformationPage from "../../Containers/ProjectInformationPage";
import InformationTargetGroupProjectModule from "../../Pages/ProjectInformationPage/InformationTargetGroupProjectModule";
import ProjectWorkPlanModule from "../../Pages/ProjectInformationPage/ProjectWorkPlanModule";
import ExpectedUnoactProjectTargetGroupModule from "../../Pages/ProjectInformationPage/ExpectedUnoactProjectTargetGroupModule";
import SectoreInformationProjectUniquenessModule from "../../Pages/ProjectInformationPage/SectoreInformationProjectUniquenessModule";
import TeamMembersModule from "../../Pages/ProjectInformationPage/TeamMembersModule";
import BudgetTimeFrame from "../../Containers/BudgetTimeFrame";
import AdvertisingAndMediaPlan from "../../Containers/AdvertisingAndMediaPlan";
import Attachments from "../../Containers/AttachmentsAndPledge";
import ProjectInformationModule from "../../Pages/ProjectInformationPage/ProjectInformationModule";

import PrepareProgressReport from "../../ContainersManager/PrepareProgressReport";
import ReportStagesPage from "../../PagesReportStage/ReportStagesPage";

import ExpectedObjectivesForStagea from "../../PagesReportStage/ExpectedObjectivesForStagea";

import LessonsLearnedPage from "../../PagesReportStage/LessonsLearnedPage";
import AssiginToEvaluters from "../../PagesManager/AssiginToEvaluters";
import MyRequestsPage from "../../PagesManager/MyRequestsPage";
import MyRequestsContainer from "../../ContainersManager/MyRequestsContainer";
import InformationSocialMediaPage from "../../PagesReportStage/InformationSocialMediaPage";
import InformationWebsitePage from "../../PagesReportStage/InformationWebsitePage";
import InformationAppPage from "../../PagesReportStage/InformationAppPage";
import ReportStageContainer from "../../ContainersManager/ReportStageContainer";
import ReportSummaryPage from "../../Containers/ReportSummaryPage";


const MainRoutsManager = () => {
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      UserInfo: state.UserInfo.UserInfo,
      RoleByUserGuid: state.RoleByUserGuid,
    };
  });
  const [list, setList] = useState([
    { id: 1, criteria: "A", answer: false, comment: "ffffff" },
    { id: 2, criteria: "A", answer: false, comment: "ffffff" },
    { id: 3, criteria: "A", answer: false, comment: "ffffff" },
    { id: 4, criteria: "B", answer: false, comment: "ffffff" },

    { id: 5, criteria: "B", answer: false, comment: "ffffff" },
    { id: 6, criteria: "C", answer: true, comment: "ffffff" },
    { id: 7, criteria: "C", answer: false, comment: "ffffff" },
  ]);

  const [markList, setMarkList] = useState([
    { id: 1, criteria: "A", weight: 100, mark: 55, comment: "ffffff" },
    { id: 2, criteria: "A", weight: 100, mark: 55, comment: "ffffff" },
    { id: 3, criteria: "A", weight: 100, mark: 55, comment: "ffffff" },
    { id: 4, criteria: "B", weight: 100, mark: 55, comment: "ffffff" },

    { id: 5, criteria: "B", weight: 100, mark: 55, comment: "ffffff" },
    { id: 6, criteria: "C", weight: 100, mark: 55, comment: "ffffff" },
    { id: 7, criteria: "C", weight: 100, mark: 55, comment: "ffffff" },
  ]);

  const [actionBtnList, setActionBtnList] = useState([
    { id: 1, text: "A", actionGuid: "e9239219-7421-408a-b743-1c21dc6f8c8c" },
    { id: 2, text: "B", actionGuid: "fg741256-7421-408a-b743-1c21dc6f8c8c" },
    { id: 3, text: "C", actionGuid: "dc789662-7421-408a-b743-1c21dc6f8c8c" },
    { id: 3, text: "D", actionGuid: "dc789662-7421-408a-b743-1c21dc6f8c8c" },
    ,
  ]);
  const tasks = [
    {
      id: 1,
      title: "Design Homepage",
      status: "In Progress",
      responsible: "Alice",
      MultiTasks: true,
      subtasks: [
        {
          id: 101,
          title: "Create wireframe",
          status: "Completed",
          responsible: "Bob",
        },
        {
          id: 102,
          title: "Finalize design",
          status: "In Progress",
          responsible: "Charlie",
        },
      ],
    },
    {
      id: 2,
      title: "Develop Backend API",
      status: "Not Started",
      responsible: "David",
      MultiTasks: false,
      subtasks: [],
    },
    {
      id: 3,
      title: "Test Application",
      status: "Not Started",
      responsible: "Grace",
      MultiTasks: true,
      subtasks: [
        {
          id: 103,
          title: "Write test cases",
          status: "Not Started",
          responsible: "Henry",
        },
        {
          id: 104,
          title: "Run manual tests",
          status: "Not Started",
          responsible: "Eve",
        },
      ],
    },
  ];

  const [Recommendations, setRecommendations] = useState({
    id: 1,
    Recommendations: 1,
    comments: "gggg",
  });
  const hasPermission = true;
  const handleUpdateList = (updatedList) => {
    setList(updatedList);
    //console.log("Updated List: ", updatedList);
  };

  const handleUpdateMarkList = (updatedList) => {
    setMarkList(updatedList);
    //console.log("Updated List: ", updatedList);
  };
  const handleUpdateRecommendations = (updatedList) => {
    setRecommendations(updatedList);
    //console.log("Updated List:setRecommendations", updatedList);
  };
  const onUpdateActionButton = (actionGuid) => {
    //console.log(actionGuid, "actionGuid");
  };
  useEffect(() => {
    dispatch(GetRoleByUserGuid(state.UserInfo?.userToken?.userGuid));
  }, []);
  //console.log(state.RoleByUserGuid, "UserInfoxxxxxxxxxx");
  return (
    <>
      <Routes>
        <Route path="/grants/manager/" element={<TasksManager />} />

        <Route
          path="/grants/manager/YesNoTable/"
          element={
            <YesNoTable
            // list={list}
            // primaryKey="id"
            // keyName="criteria"
            // keyName2="answer"
            // keyName3="comment"
            // qustionGroup="criteria"
            // onUpdateList={handleUpdateList}
            />
          }
        />
        {/* ////////////////////////////////////////////////////////////////////////  */}
        <Route
          path="/grants/manager/ApplicationInformation/:AppGuid"
          element={<ApplicantInformatonPage />}
        />
        <Route
          path="/grants/manager/InformationProject/:AppGuid"
          element={<ProjectInformationPage location={"manager"} />}
        />
        <Route
          path="/grants/manager/InformationProject/InformationProjectSub/:AppGuid"
          element={<ProjectInformationModule />}
        />
        <Route
          path="/grants/manager/InformationProject/TargetAudience/:AppGuid"
          element={<InformationTargetGroupProjectModule />}
        />
        <Route
          path="/grants/manager/InformationProject/projectPlan/:AppGuid"
          element={<ProjectWorkPlanModule />}
        />
        <Route
          path="/grants/manager/InformationProject/ImpactSustainability/:AppGuid"
          element={<ExpectedUnoactProjectTargetGroupModule />}
        />
        <Route
          path="/grants/manager/InformationProject/sectorInfo/:AppGuid"
          element={<SectoreInformationProjectUniquenessModule />}
        />

        <Route
          path="/grants/manager/InformationProject/TeamPartnerships/:AppGuid"
          element={<TeamMembersModule />}
        />

        <Route
          path="/grants/manager/BudgetTimeFrame/:AppGuid"
          element={<BudgetTimeFrame />}
        />

        <Route
          path="/grants/manager/AdvertisingAndMediaPlan/:AppGuid"
          element={<AdvertisingAndMediaPlan />}
        />

        <Route
          path="/grants/manager/AttachmentsAndPledge/:AppGuid"
          element={<Attachments />}
        />

        {/* ////////////////////////////////////////////////////////////////////////  */}

        <Route
          path="/grants/manager/RecommendationsSection/"
          element={<RecommendationsSection />}
        />

        <Route
          path="/grants/manager/RequestsManager/"
          element={<RequestsManager />}
        />
        <Route
          path="/grants/manager/AllComponentPage/:flow/:taskId/:mainTaskId"
          element={<AllComponentPage />}
        />
        <Route
          path="/grants/manager/TasksManager/"
          element={<TasksManager />}
        />
        <Route
          path="/grants/manager/AllComponentPageMainTask/:flow/:taskId/:taskStatusGUID/:userGuid"
          element={<AllMainComponentsPage />}
        />
        <Route
          path="/grants/manager/ButtonActionManager/"
          element={
            <SharedDiv
              showTitle={true}
              titleName="اخذ اجراء"
              child={[
                <ButtonActionManager
                  list={actionBtnList}
                  onUpdateActionButton={onUpdateActionButton}
                />,
              ]}
            />
          }
        />
        <Route
          path="/grants/manager/SingleTaskManager/"
          element={<SingelTaskManagerContainer />}
        />


        <Route
          path="/grants/manager/AssiginToEvaluters/"
          element={<AssiginToEvaluters />}
        />
        <Route
          path="/grants/manager/MyRequestsPage/"
          element={<MyRequestsContainer />}
        />

        <Route
          path="/grants/manager/PrepareProgressReport/:token"
          element={<PrepareProgressReport />}
        />
        <Route path="/grants/manager/Report/" element={<ReportStagesPage />} />

        <Route
          path="/grants/manager/ReportStageContainerManager/:stageGuid"
          element={<ReportStageContainer location="manager" />}
        />

        <Route
          path="/grants/manager/ReportSummaryPage/:reportId"
          element={<ReportSummaryPage location="manager" />}
        />
      </Routes>
    </>
  );
};

export default MainRoutsManager;
